export default function getRouteAndParams() {
  let orgHash = window.location.hash;

  if (!orgHash) {
    return {
      hash: null,
      params: null,
    };
  }
  let params = {};
  let hash = null;
  //do we have params?
  const indexOfQuestionMark = orgHash.indexOf("?");

  if (indexOfQuestionMark > 0) {
    params = orgHash.substring(indexOfQuestionMark + 1);
    hash = orgHash.substring(0, indexOfQuestionMark);

    if (params) {
      params = parseQuery(params);
    }
  } else {
    hash = orgHash;
  }
  return {
    route: hash,
    params,
  };
}

function parseQuery(queryString) {
  var query = {};
  var pairs = (queryString[0] === "?"
    ? queryString.substr(1)
    : queryString
  ).split("&");
  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i].split("=");
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "");
  }
  return query;
}
